import React from "react";
import { FiZap } from "react-icons/fi";
import nodata from "../../../../Utils/assets/img/leads_no_data_found_removebg.png";
import { formatDate, formatToINR } from "../../../../Utils/helpers/commonhelper";
import { COLORS, STATUS_STYLE, OWNER_COLORS, TABLE_RANGES } from "../myDashboardConstants";
import { ownerInitials } from "../utils";
import { SectionCard1 } from "../components/SectionCards";
import { RangeTabs } from "../components/RangeTabs";
import { Avatar } from "../components/Avatar";
import { Badge } from "../components/Badge";

export function HotLeadsTable({ data, range, onRangeChange }) {
  return (
    <SectionCard1
      title="Hot Leads"
      subtitle="Ranked by AI score"
      icon={<FiZap size={16} />}
      accent={COLORS.danger}
      action={
        <RangeTabs
          value={range}
          onChange={onRangeChange}
          options={TABLE_RANGES}
        />
      }
    >
      <div className="sd-table-wrap">
        <table className="sd-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Owner</th>
              <th>Stage</th>
              <th>Status</th>
              <th>Deal Value</th>
              <th>Expected Close</th>
            </tr>
          </thead>
          <tbody>
            {!data?.length ? (
              <tr>
                <td colSpan="6" style={{ padding: 0, border: "none" }}>
                  <div
                    style={{
                      height: 300,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={nodata}
                      alt="No data found"
                      style={{ width: "14rem", maxWidth: "80%" }}
                    />
                  </div>
                </td>
              </tr>
            ) : (
              data.map((l, i) => {
                return (
                  <tr key={l?.lead_no}>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <div>
                          <div className="sd-table-strong">
                            {l?.lead_no || "-"}
                          </div>
                          <div
                            className="sd-table-muted"
                            style={{ fontSize: 11 }}
                          >
                            {l?.company_name || "-"}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        style={{ display: "flex", alignItems: "center", gap: 8 }}
                      >
                        <Avatar
                          initials={ownerInitials(l?.owner_name)}
                          color="#fff"
                          soft={OWNER_COLORS[i % OWNER_COLORS.length]}
                        />
                        <span>{l?.owner_name || "-"}</span>
                      </div>
                    </td>
                    <td>
                      <Badge
                        label={l?.stage_name || "-"}
                        styleMap={STATUS_STYLE}
                      />
                    </td>
                    <td>
                      <Badge label={l?.lead_status || "-"} />
                    </td>
                    <td className="sd-table-strong">
                      {formatToINR(l?.total_budget || 0)}
                    </td>
                    <td className="sd-table-muted">{formatDate(l?.expected_closure_date)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </SectionCard1>
  );
}
